import { render } from "./GameThreeWinText.vue?vue&type=template&id=67fa4de7"
import script from "./GameThreeWinText.vue?vue&type=script&lang=js"
export * from "./GameThreeWinText.vue?vue&type=script&lang=js"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__